import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    INVOICE_ITEM_TYPES,
    INVOICE_ORIGIN,
    ONLINE_PURCHASE_INVOICE_DESCRIPTION,
    RESERVATION_MESSAGES
} from '../../../../collums-constants';
import { calculateTaxValue, roundTwoDecimals } from '../../../../collums-constants/utils';
import InvoiceApi from '../../../../api/invoiceApi';
import { Button, withStyles } from '@material-ui/core';
import { coherentIframeStyles as styles } from './styles';
import CoherentApi from '../../../../api/coherentApi';
import CoursesApi from '../../../../api/coursesApi';
import TaxesApi from '../../../../collums-components/api/TaxesApi';
import { toastr } from 'react-redux-toastr';
// import { getCourseContext } from '../../../../redux/selectors/book-appointment';

let coherentIntervalId = null;

const CoherentCreditCard = ({
    classes,
    // bookingDeposit,
    // accountBalance,
    deposit,
    // price,
    handleNext,
    coherentTransactionId,
    setCoherentTransactionId,
    savedAppointmentId
}) => {
    const customerId = useSelector(state => state.auth.user.id);
    const [coherentUrl, setCoherentUrl] = useState(null);
    // const [deposit, setDeposit] = useState(null);
    const state = useSelector(state => state.bookAppointment);
    // const courseContext = useSelector(getCourseContext);

    const [draftInvoiceData, setDraftInvoiceData] = useState(null);

    useEffect(() => {
        const stepElement = document.querySelector('.MuiStepper-root');
        if (stepElement) {
            setTimeout(() => {
                stepElement.scrollIntoView({ behavior: 'instant', block: 'start' });
            }, 100);
        }
    }, []);

    useEffect(() => {
        startCoherentInterval();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coherentTransactionId]);

    /**
     * Invoice should generate once again if price, step or customer id has changed.
     */
    useEffect(() => {
        setDraftInvoiceData(null);
    }, [customerId, deposit, state.currentStep]);

    // useEffect(() => {
    //     // make sure deposit amount is set.
    //     if (!isNaN(parseFloat(bookingDeposit?.bookingDepositAmount))) {
    //         let depositValue = 0;
    //
    //         if (bookingDeposit.bookingDepositType === DEPOSIT_TYPES.PERCENTAGE) {
    //             depositValue = price * (bookingDeposit.bookingDepositAmount / 100);
    //         } else if (bookingDeposit.bookingDepositAmount) {
    //             depositValue = bookingDeposit.bookingDepositAmount;
    //         }
    //
    //         // if (accountBalance && accountBalance > 0) {
    //         //     depositValue = depositValue - accountBalance;
    //         // }
    //
    //         depositValue = Math.round(depositValue * 100) / 100;
    //
    //         if (depositValue < 0) {
    //             depositValue = 0;
    //         }
    //
    //         setDeposit(depositValue);
    //     } else {
    //         setDeposit(0);
    //     }
    // }, [bookingDeposit, price]);

    useEffect(() => {
        (async () => {
            if (deposit > 0) {
                let invoice = draftInvoiceData;
                if (!invoice) {
                    invoice = await saveInvoice();
                    if (invoice) {
                        setDraftInvoiceData(invoice);
                        // create payment, get coherent transaction url
                        const result = await addPayment(invoice);

                        if (result) {
                            if (result?.coherentUrl) {
                                setCoherentUrl(result.coherentUrl);
                            }
                            if (result?.coherentTransactionId) {
                                setCoherentTransactionId(result.coherentTransactionId);
                            }
                        }
                    }
                }
            } else if (deposit === 0) {
                handleNext();
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId, deposit]);

    const refreshPaymentForm = async () => {
        if (!draftInvoiceData) return;

        try {
            const result = await addPayment(draftInvoiceData);

            if (result?.coherentUrl) {
                setCoherentUrl(result.coherentUrl);
            }

            if (result?.coherentTransactionId) {
                setCoherentTransactionId(result.coherentTransactionId);
            }
        } catch (err) {
            toastr.error(err?.data?.message || err?.message || 'Something went wrong');
            setTimeout(() => {
                window.location.href = '/app';
            }, 3000);
        }
    };

    const startCoherentInterval = () => {
        if (coherentTransactionId) {
            let alreadySent = false;
            coherentIntervalId = setInterval(async () => {
                const result = await CoherentApi.checkPayment(coherentTransactionId);
                if (result.isPaid && !alreadySent) {
                    clearInterval(coherentIntervalId);
                    alreadySent = true;

                    const isCourseOnly = state.currentAppointments.every(app => app?.service?.salePrice);
                    if (isCourseOnly && draftInvoiceData) {
                        try {
                            // eslint-disable-next-line
                            const verificationResult = await CoursesApi.verifyCourseAssignment(draftInvoiceData.id);
                        } catch (error) {
                            console.error('Course assignment verification failed:', error);
                        }
                    }

                    setTimeout(() => {
                        handleNext();
                    }, 3000);
                }
                if (result.isVoid) {
                    toastr.error(RESERVATION_MESSAGES.TIME_EXPIRED);
                    setTimeout(() => {
                        window.location.href = '/app';
                    }, 3000);
                }
            }, 3000);
        }
    };

    const saveInvoice = async () => {
        const isCourseOnly =
            state.currentAppointments.length && state.currentAppointments.every(app => app?.service?.salePrice);
        const isGiftVoucherOnly = !!state.currentGiftVouchers.length;

        let items;
        let description;
        let invoiceAmount;

        if (isCourseOnly) {
            items = await Promise.all(
                state.currentAppointments.map(async courseAppt => {
                    const salePrice = courseAppt.service.salePrice;
                    let taxDecimal = 0;

                    try {
                        if (courseAppt.service.itemTax && typeof courseAppt.service.itemTax.rate === 'number') {
                            const taxPercentage = courseAppt.service.itemTax.rate;
                            taxDecimal = taxPercentage / 100;

                            courseAppt.taxRateToSend = taxPercentage;
                        } else if (courseAppt.service.tax) {
                            const taxData = await TaxesApi.getTaxesForItem(courseAppt.service.tax);

                            if (taxData && typeof taxData.rate === 'number') {
                                const taxPercentage = taxData.rate;
                                taxDecimal = taxPercentage / 100;
                                courseAppt.taxRateToSend = taxPercentage;
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }

                    const netPrice = roundTwoDecimals(salePrice / (1 + taxDecimal));

                    const taxValue = calculateTaxValue({
                        tax: taxDecimal,
                        netPrice: netPrice,
                        quantity: 1
                    });

                    const invoiceItem = {
                        location: state.currentLocation.id,
                        type: INVOICE_ITEM_TYPES.COURSE,
                        name: courseAppt.service.name || courseAppt.service.onlineName,
                        discount: 0,
                        tax: courseAppt.taxRateToSend || 0, // Send percentage rate (like POS), backend will convert to decimal
                        taxValue: taxValue,
                        quantity: 1,
                        finalPrice: salePrice,
                        grossPrice: netPrice + taxValue,
                        netPrice: netPrice,
                        listPrice: salePrice,
                        referenceId: courseAppt.service.id,
                        onlineSale: true
                    };
                    return invoiceItem;
                })
            );
            description = 'Online Course Purchase';
            invoiceAmount = state.currentAppointments.reduce((total, app) => total + (app.service.salePrice || 0), 0);
        } else if (isGiftVoucherOnly) {
            items = await Promise.all(
                state.currentGiftVouchers.map(async gv => {
                    const salePrice = gv.value;
                    const netPrice = gv.value;

                    const invoiceItem = {
                        location: state.currentLocation.id,
                        type: INVOICE_ITEM_TYPES.GIFTCARD,
                        name: 'Gift voucher',
                        discount: 0,
                        tax: 0,
                        taxValue: 0,
                        quantity: 1,
                        finalPrice: salePrice,
                        grossPrice: netPrice,
                        netPrice: netPrice,
                        listPrice: salePrice,
                        referenceId: null,
                        onlineSale: true,
                        ...(gv.receiver ? { giftVoucherReceiver: gv.receiver } : {})
                    };
                    return invoiceItem;
                })
            );
            description = ONLINE_PURCHASE_INVOICE_DESCRIPTION.GIFT_VOUCHER;
            invoiceAmount = state.currentGiftVouchers.reduce((total, gv) => total + (gv.value || 0), 0);
        } else {
            items = [
                {
                    location: state.currentLocation.id,
                    type: 'Account',
                    name: 'Account',
                    discount: 0,
                    tax: 0,
                    taxValue: 0,
                    quantity: 1,
                    finalPrice: deposit,
                    grossPrice: deposit,
                    netPrice: deposit,
                    listPrice: deposit
                }
            ];
            description = 'Invoice for Booking Deposit';
            invoiceAmount = deposit;
        }

        const invoiceDraft = {
            customer: customerId,
            items,
            discount: 0,
            description: description,
            origin: isCourseOnly ? INVOICE_ORIGIN.ONLINE_COURSE : INVOICE_ORIGIN.SALE,
            discountProperties: undefined,
            amount: invoiceAmount,
            temporaryDiscount: undefined,
            clinic: state.currentLocation.id,
            isDraft: true
        };
        return await InvoiceApi.saveInvoice(invoiceDraft);
    };

    const addPayment = async invoice => {
        const isCourseOnly = savedAppointmentId && savedAppointmentId.toString().startsWith('course-only-');
        const isCoursePurchase =
            state.currentAppointments.length && state.currentAppointments.every(app => app?.service?.salePrice);

        let paymentValue;
        if (isCoursePurchase) {
            paymentValue = state.currentAppointments.reduce((total, app) => total + (app.service.salePrice || 0), 0);
        } else {
            paymentValue = deposit;
        }

        const payment = {
            notifications: { email: true, SMS: false },
            payments: [
                {
                    coherentPaymentFlag: true,
                    value: paymentValue,
                    discount: 0,
                    type: 'Card',
                    cardData: {}
                }
            ],
            invoice: {
                id: invoice.id,
                customer: invoice.customer,
                code: invoice.code,
                taxPercentages: 0
            }
        };

        if (!isCourseOnly && savedAppointmentId) {
            payment.appointmentId = savedAppointmentId;
        }

        return await InvoiceApi.addInvoicePayment(payment);
    };

    return (
        <div className={classes.wrapper}>
            {coherentUrl && (
                <>
                    <iframe
                        id="coherent-iframe"
                        className={classes.iframe}
                        src={coherentUrl}
                        title="coherent-iframe"
                        allow="payment"
                    />
                    <div className={classes.coherentActions}>
                        <Button onClick={() => refreshPaymentForm()} variant="outlined">
                            Start again
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default withStyles(styles)(CoherentCreditCard);
